<template>
  <div>
    <!-- loading -->
    <div v-if="status === 'loading'" class="text-xs-center">
      <v-progress-circular class="my-3" indeterminate color="accent" :size="50"></v-progress-circular>
    </div>

    <!-- error -->
    <div v-if="status === 'error'" class="text-xs-center">
      <p class="grey--text">{{ $t('Common.genericErrorMsg') }}</p>
      <v-btn depressed color="accent" round @click="tryAgain">
        <v-icon left>refresh</v-icon>
        {{ $t('Common.tryAgain') }}
      </v-btn>
    </div>

    <!-- success -->
    <div v-if="status === 'success'">
      <form class="form--custom" novalidate @submit.prevent="handleSubmit">
        <v-text-field
          v-model="budgetLimit"
          v-money="money"
          required
          flat
          outline
          solo
          color="accent"
          :placeholder="$t(`${namespace}.dailyLimitOfCreditsPlaceholder`)"
          :error-messages="errors.first($t(`${namespace}.dailyLimitOfCreditsLabel`))"
          v-validate="{ required: true }"
          :data-vv-name="$t(`${namespace}.dailyLimitOfCreditsLabel`)"
        />

        <v-layout>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isSaving"
            class="text--normal"
            color="accent"
            flat
            round
            @click="close"
          >
            {{ $t('Common.cancel') }}
          </v-btn>

          <v-btn
            type="submit"
            round
            depressed
            color="accent"
            :disabled="isSaving"
            :loading="isSaving"
          >
            {{ $t('Common.save') }}
          </v-btn>
        </v-layout>

        <div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VMoney } from 'v-money'
import { convertToCurrencyBRL } from 'utils/functions'

export default {
  name: 'DailyLimitOfCredits',
  props: {
    financialConfig: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: 'loading'
    }
  },
  directives: {
    money: VMoney
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    }),

    routeId () {
      if (this.$route.params.id) {
        return Number(this.$route.params.id)
      }

      if (this.company) {
        return this.company.id
      }

      return null
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePoliciesPage',
      budgetLimit: null,
      isSaving: false,

      // mask
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    tryAgain () {
      this.$emit('tryAgain')
    },

    close () {
      this.$emit('close')
    },

    normalizeString (str) {
      if (!str || str === 'R$ 0,00') return 0
      return Number(str.replace(/R\$\s/, '').replace('.', '').replace(',', '.'))
    },

    async handleSubmit () {
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) return
        this.isSaving = true
        await this.$apiService.editCompanyFinancialConfig(
          this.routeId,
          { budgetLimit: this.normalizeString(this.budgetLimit) }
        )
        this.$emit('success')
        this.successAlert(this.$t(`${this.namespace}.dailyLimitOfCreditsSuccess`))
      } catch (err) {
        console.log('Error', err)
        this.errorAlert(this.$t(`${this.namespace}.dailyLimitOfCreditsError`))
      }

      this.isSaving = false
    }
  },
  watch: {
    status (val) {
      if (val === 'success') {
        this.budgetLimit = convertToCurrencyBRL(this.financialConfig)
      }
    }
  },
  created () {
    this.budgetLimit = convertToCurrencyBRL(this.financialConfig)
  }
}
</script>
